
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
name: "alliance_myexchange",
components: {
Tab,
TabItem,
Swiper,
SwiperItem
},
data() {
return {
title: "我的兑换",
tabs: ["待使用", "已使用", "已失效"],
demo2: "待使用", //默认显示状态
page: 1, //获取第几页数据
per_page: "5", //每一页条数
status: 0, //优惠券状态  1=待使用 2=已使用 3=已失效
gifs: [],
url: window.location.href,//当前地址
gifsShow:true,//列表有无数据
};
},
created() {
if (sessionStorage.getItem("token") == null) {
this.get_token(this.url);
}
},
methods: {

get_token(url) {
var self = this;
this.$EpetJs.Common.approve(url, function() {
self.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
}); //生成token
},

change(item, index) {
this.status = index;
this.gifs = [];
this.page = 1;
this.$nextTick(() => {
this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
});
},

get_gifs($state) {
var self = this;
var changestatus = this.status + 1;
this.$EpetJs.Common.get(
"/v2/public/user/gifts?page=" +
this.page +
"&status=" +
changestatus,
{}
).then(({ data }) => {
if (data.status_code == "200") {

if (data.data.length > 0) {
self.gifs = self.gifs.concat(data.data);
self.page += 1;
$state.loaded();
} else {
$state.complete();
}
if( self.gifs==''){
self.gifsShow=false;
}else{
self.gifsShow=true;
}
}
});
},
infiniteHandler($state) {
this.get_gifs($state);
},

godetail(id) {
if (this.status == 0) {
this.$router.push({
name: "alliance_coupondetail",
query: { id: id }
});
}
}
}
};
